import { createSlice } from "@reduxjs/toolkit";
import { fetchLawReportTableColumnNames, fetchLawReport, fetchLawStatus, 
  fetchArticleStatus, fetchInstrumentType, updateJsonField, updateJsonStatus
 } from "../thunks";

const initialState = {
  documents: [],
  tableColumnNames: [],
  lawStatus: [],
  articleStatus: [],
  instrumentType: [],
  page: 1,
  perPage: 10,
  totalRecords: 0,
  loading: false,
  error: null
};

const LawReportSlice = createSlice({
  name: "LawReport",
  initialState,
  reducers: {
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setPerPage: (state, action) => {
      state.perPage = action.payload;
      state.page = 1; // ✅ Reset page on perPage change
    },
    updateLawReport: (state, action) => {
      const updatedReport = action.payload;
      state.documents = state.documents.map((item) =>
        item.ID === updatedReport.ID ? updatedReport : item
      );
    },
    clearLawDocuments: (state) => {
      state.documents = []
    }
  },
  extraReducers: (builder) => {
    builder

    // Fetch Human Categories Table Column Names
    .addCase(fetchLawReportTableColumnNames.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchLawReportTableColumnNames.fulfilled, (state, action) => {
      state.loading = false;
      state.tableColumnNames = action.payload;
    })
    .addCase(fetchLawReportTableColumnNames.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    })
    .addCase(fetchLawReport.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchLawReport.fulfilled, (state, action) => {
      state.loading = false;
      state.documents = action.payload.data;
      state.totalRecords = action.payload.totalRecords;
    })
    .addCase(fetchLawReport.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    })
    .addCase(fetchLawStatus.pending, (state) => {
      state.error = null;
    })
    .addCase(fetchLawStatus.fulfilled, (state, action) => {
      state.lawStatus = action.payload;
    })
    .addCase(fetchLawStatus.rejected, (state, action) => {
      state.error = action.payload;
    })
    .addCase(fetchArticleStatus.pending, (state) => {
      state.error = null;
    })
    .addCase(fetchArticleStatus.fulfilled, (state, action) => {
      state.articleStatus = action.payload;
    })
    .addCase(fetchArticleStatus.rejected, (state, action) => {
      state.error = action.payload;
    })
    .addCase(fetchInstrumentType.pending, (state) => {
      state.error = null;
    })
    .addCase(fetchInstrumentType.fulfilled, (state, action) => {
      state.instrumentType = action.payload;
    })
    .addCase(fetchInstrumentType.rejected, (state, action) => {
      state.error = action.payload;
    })
    .addCase(updateJsonField.pending, (state) => {
      state.error = null;
    })
    .addCase(updateJsonField.fulfilled, (state, action) => {
      state.documents = state.documents.map((item) =>
        item.ID == action.payload.ID
          ? { ...item, JsonFieldUpdated: action.payload.JsonFieldUpdated }
          : item
      );
    })
    .addCase(updateJsonField.rejected, (state, action) => {
      state.error = action.payload;
    })
    .addCase(updateJsonStatus.pending, (state) => {
      state.error = null;
    })
    .addCase(updateJsonStatus.fulfilled, (state, action) => {
      state.documents = state.documents.map((item) =>
        item.ID === action.payload.ID
          ? { ...item, JsonStatus: action.payload.JsonStatus }
          : item
      );
    })
    .addCase(updateJsonStatus.rejected, (state, action) => {
      state.error = action.payload;
    })
  },
});

export const { setPage, setPerPage, updateLawReport, clearLawDocuments } = LawReportSlice.actions;
export default LawReportSlice.reducer;